import axiosInstance from "../server/axios";

// export const fetchAchats = async (search, perPage, currentPage) => {
//     const token = localStorage.getItem('authToken');
//     const response = await axiosInstance.get(`/indexAchatOffres`,{
//         headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//         },
//         params: {
//             search,
//             perPage,
//             currentPage
//         }
//     });

//     return response.data;
// };
export const fetchAchats = async (filters = {}) => {
    const token = localStorage.getItem('authToken');
    const response = await axiosInstance.get(`/indexAchatOffres`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        params: {
            ...filters,
            perPage: filters.perPage || 10,
            page: filters.currentPage || 1
        }
    });
    return response.data;
};

export const fetchUnpaidAchats = async (filters = {}) => {
    const token = localStorage.getItem('authToken');
    const response = await axiosInstance.get(`/indexUnpaidAchatOffres`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        params: {
            ...filters,
            perPage: filters.perPage || 10,
            page: filters.currentPage || 1
        }
    });
    return response.data;
};
export const getAllVentes = async () => {
    const token = localStorage.getItem('authToken');
    const response = await axiosInstance.get(`/getAllVentes`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    return response.data;
}

export const confirmAchat = async (data, achatId) => {
    const token = localStorage.getItem('authToken');
    const response = await axiosInstance.post(`/reglement-ventes/${achatId}`, { reglements: data }, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    return response.data;
}

// Nouveaux services pour l'ajout manuel d'achat - CORRIGÉ
export const createManualAchat = async (formData) => {
    const token = localStorage.getItem('authToken');
    const response = await axiosInstance.post(`/admin/achat/manual`, formData, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
};

export const getAchatFormData = async () => {
    const token = localStorage.getItem('authToken');
    const response = await axiosInstance.get(`/admin/achat/form-data`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    return response.data;
};

export const updateAchat = async (achatId, data) => {
    const token = localStorage.getItem('authToken');
    const response = await axiosInstance.put(`/admin/achat/${achatId}`, data, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    return response.data;
};

export const deleteAchat = async (achatId) => {
    const token = localStorage.getItem('authToken');
    const response = await axiosInstance.delete(`/admin/achat/${achatId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    return response.data;
};

export const getAchatDetails = async (achatId) => {
    const token = localStorage.getItem('authToken');
    const response = await axiosInstance.get(`/admin/achat/${achatId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    return response.data;
};